import React from 'react';

import { Paragraph as PrismParagraph } from '@nutanix-ui/prism-reactjs';
import type { ParagraphProps as PrismParagraphProps } from '@nutanix-ui/prism-reactjs/lib/components/v2/Typography/Paragraph';

export { ParagraphAppearance } from '@nutanix-ui/prism-reactjs/lib/components/v2/Typography/Paragraph';
export type { ParagraphProps } from '@nutanix-ui/prism-reactjs/lib/components/v2/Typography/Paragraph';

export default function Paragraph(props: React.PropsWithChildren<PrismParagraphProps>) {
  return <PrismParagraph {...props} />;
}
